import YContainer from './src/main'

YContainer.install = function(Vue) {
  Vue.component(YContainer.name, YContainer)
}

export default YContainer
